import{CONST_KEY as n}from"./constants.esm.js";function r(r){return Array.isArray(r.enum)&&1===r.enum.length||n in r}export{r as default};
